import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withCommonGameConfiguration from "../../core/components/commongame/configuration/withCommonGameConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";

import { TIMER } from "../../core/utills";

import * as PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import {
    configGame, constant
} from "../../data/config";

import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";


interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}

interface IStateToProps {

    basegamestate: any,
    resizeWidth: any,
    layoutMode: string,
    inFreeGame: boolean
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class GameCommonGame extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected gameCommonGameContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected bgImageDesktop: any;
    protected fgImageDesktop: any;
    protected bgImageLandscape: any;
    protected fgImageLandscape: any;
    protected bgImagePortrait: any;
    protected fgImagePortrait: any;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en",
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            resizing: false,
        }
        this.gameCommonGameContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";

        }
        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
        this.layoutChange(this.props.layoutMode);
        this.initializeObjectToVariable();
        this.imageChangingMethod(this.props);
    }


    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    imageChangingMethod(nextProps: any) {
        if (nextProps.basegamestate) {
            if (this.ui_mode === "mobile") {
                if (window.innerWidth > window.innerHeight) {
                    this.bgImageLandscape.visible = true;
                    this.fgImageLandscape.visible = false;
                    this.bgImagePortrait.visible = false;
                    this.fgImagePortrait.visible = false;

                } else {
                    this.bgImagePortrait.visible = true;
                    this.fgImagePortrait.visible = false;
                    this.bgImageLandscape.visible = false;
                    this.fgImageLandscape.visible = false;
                }

            } else {
                this.bgImageDesktop.visible = true;
                this.fgImageDesktop.visible = false;


            }
        }
        else {

            if (this.ui_mode === "mobile") {
                if (window.innerWidth > window.innerHeight) {
                    this.bgImageLandscape.visible = false;
                    this.fgImageLandscape.visible = true;
                    this.bgImagePortrait.visible = false;
                    this.fgImagePortrait.visible = false;
                } else {
                    this.bgImagePortrait.visible = false;
                    this.fgImagePortrait.visible = true;
                    this.bgImageLandscape.visible = false;
                    this.fgImageLandscape.visible = false;

                }

            } else {
                this.bgImageDesktop.visible = false;
                this.fgImageDesktop.visible = true;
            }
        }
    }


    initializeObjectToVariable() {
      
        this.bgImageDesktop = UIManager.getRef("image_basegame-bg_desktop");
        this.fgImageDesktop = UIManager.getRef("image_freegame-fg");
        this.bgImageLandscape = UIManager.getRef("image_basegame-bg_mobile");
        this.fgImageLandscape = UIManager.getRef("image_freegame-fg");
        this.bgImagePortrait = UIManager.getRef("image_commongame-potrait-bg");
        this.fgImagePortrait = UIManager.getRef("image_commongame-potrait-fg");
    }

    componentDidMount() {
        this.bindUI();
        this.imageChangingMethod(this.props);
    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.layoutMode !== this.props.layoutMode
            || nextProps.basegamestate !== this.props.basegamestate
            || nextProps.inFreeGame !== this.props.inFreeGame

        ) {
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
                let timer1 = TIMER.TimerManager.createTimer(50);
                timer1.on('end', (i: number) => {

                    this.imageChangingMethod(nextProps);

                });
                timer1.start();


            }
            if (nextProps.inFreeGame) {
                this.imageChangingMethod(nextProps);
            }
            if (nextProps.basegamestate) {

                this.imageChangingMethod(nextProps);

            }
            if (!nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {              
                this.imageChangingMethod(nextProps);
            }

            return false;
        }
        return true;
    }


    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.initializeObjectToVariable();
    }

    render() {

        return (
            <UIManager id={"gameCommonGameContainer"} name={"gameCommonGameContainer"} type={"Container"}
                ref={i => this.gameCommonGameContainer = i} configGame={configGame}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            app={this.app} configGame={configGame}
                            id={i.id} {...i} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'basegameState' | 'applicationState' | 'SQModelState' | 'freegameState'>): IStateToProps =>
    ({
        basegamestate: state.basegameState.basegamestate,
        layoutMode: state.applicationState.layoutMode,
        resizeWidth: state.applicationState.resizeWidth,
        inFreeGame: state.freegameState.inFreeGame,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(withCommonGameConfiguration(GameCommonGame)));